import { Component, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { label } from 'src/app/constants/labels';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { BaseAPIService } from 'src/app/shared/services/api.base.service';
import { environment } from 'src/environments/env-proxy';

//const environment = (window as any).__env
@Component({
  selector: 'app-sp-support',
  templateUrl: './sp-support.component.html',
  styleUrls: ['./sp-support.component.scss']
})
export class SpSupportComponent implements OnInit {
  cols: { field: string; header: string; width: string}[];
  labels = label;
  tickets = [];
  addIssuePopup = false;
  files = [];
  fileTypeError: boolean;
  fileSizeError: boolean;
  file: string;
  title = '';
  description = '';
  priority = '';
  showModal: boolean;
  isAdmin: string;
  resolution = '';
  deletePopup = false;
  rowdata: {title : string, description : string , status : string};
  expandIssue = false;
  issueTitle: string;
  issueDesc: string;
  issuePriority: string;
  loader = false;
  issueStatus: string;
  issueId: string;
  errorSameFile: string;
  fileList= [];
  confirmResolve = false;
  loading = true;
  createdBy: string;
  createdEmail: string;
  createdDate: string;
  attachments: [];
  comments: [];
  ticketData: FormData;
  ticketId: number;
  reOpenComment = '';
  loaderFullPage = false;
  adminUsers: [];
  ticketPriorityList: [];
  loaderCreate = false;
  confirmReOpen = false;

  ticketAssignee = '0';
  textValid: boolean;
  errorText: string;
  validText = {
    resolutionText : false,
    reOpenText: false,
    title: false,
    description: false,
    priority: false
  }
  url: string;
  searchText = '';
  
  constructor(private readonly authenticationService: AuthenticationService, private readonly toastr: ToastrService, private readonly baseService: BaseAPIService) { }
   /**
   * intilize the support component
   */
  ngOnInit() {
    this.labels = label;
    this.addIssuePopup = false;
    this.cols = [
      { field: 'ticketId', header: 'Ticket Id', width: '7%'},
      { field: 'title', header: 'Title',  width: '12%' },
      { field: 'description', header: 'Description',  width: '20%' },
      { field: 'priorityName', header: 'Priority',  width: '7%' },
      { field: 'createdBy', header: 'Created by', width: '9%'},
      { field: 'email', header: 'Email', width: '13%'},
      { field: 'createdOn', header: 'Created On(UTC Time)',  width: '13%'},
      { field: 'assignedTo', header: 'Assigned To', width: '15%'},
      { field: 'status', header: 'Status',  width: '8%'}
    ];
    this.isAdmin = this.authenticationService.adminRole;
    if(this.isAdmin === "true"){
      this.getAllAdmins();
    }
    this.getAllTickets();
    this.getPriority();
  }
    /**
     * To get priority
     */
    getPriority(){
      ///console.log(environment.defaultLanguage);
      this.baseService.GET(environment.serverUrl + '/api/Support/TicketPriority').subscribe((response : []) => {
      this.ticketPriorityList = response;
      })
    }
   /**
   * To get all admin users
   */
  getAllAdmins(){
    this.baseService.GET(environment.serverUrl + '/api/user/GetAllAdminUser').subscribe((response : []) => {
      this.adminUsers = response;
    })
  }
  /**
   * To get all tickets for admin and User roles
   */
  getAllTickets(){
    this.loading = true;
    let requrl;
    if(this.isAdmin === 'true'){
       requrl = '/api/Support/GetAllTicketByAppId';
      
    }else{
       requrl = '/api/Support/GetAllTicketByEmail';
    }
    this.baseService.GET(environment.serverUrl + requrl).subscribe((response: []) => {
      this.tickets = response;
      this.loading = false;
    },
    // istanbul ignore next
      (_error) => {
        this.loading = false;
        this.toastr.error(label.fetcherrTicket, '', {
          timeOut: environment.toasterTimeOut
        });
      });
  }

 /**
   * To get all attachments for the selected ticket
   */
  getAllAttachmets(id: number){
    this.loaderFullPage =  true;
    if(this.isAdmin === 'true'){
      this.url = '/api/Support/GetAllAttachmentsListByTicketId';
    }else{
      this.url ='/api/Support/GetAllAttachmentsListByTicketIdAndEmail';
    }
    this.baseService.GET(environment.serverUrl + `${this.url}/${id}`).subscribe((response: []) => {
      this.attachments = response;
      this.loaderFullPage =  false;
    },
    // istanbul ignore next
      (_error) => {
        this.loaderFullPage =  false;
        this.toastr.error(label.fetcherrAttachment, '', {
          timeOut: environment.toasterTimeOut
        });
      });
  }
  /**
   * To get all comments for the selected ticket
   */
  getAllComments(id: number){
    this.loaderFullPage =  true;
    if(this.isAdmin === 'true'){
      this.url = '/api/Support/GetAllCommentsByTicketId';
    }else{
      this.url ='/api/Support/GetAllCommentsByTicketIdAndEmail';
    }
    this.baseService.GET(environment.serverUrl + `${this.url}/${id}`).subscribe((response: []) => {
      this.comments = response;
      this.loaderFullPage =  false;
    },
    // istanbul ignore next
      (_error) => {
        this.loaderFullPage =  false;
        this.toastr.error(label.fetcherrComments, '', {
          timeOut: environment.toasterTimeOut
        });
      });
  }
  /**
   * for Open Add ticket modal dialog
   */
  addNewIssue(){
    this.title = '';
    this.description = '';
    this.file = '';
    this.showModal = true;
  }
  /**
   * To create new ticket 
   */
  addTicket(){
    this.loaderCreate = true;
    this.ticketData = new FormData();
    this.ticketData.set('Title', this.title);
    this.ticketData.set('Description', this.description);
    this.ticketData.set('Priority', this.priority);
    for (const file of this.fileList) {
      this.ticketData.append('Attachments', file, file.name);
    }
    this.baseService.POST_Files(environment.serverUrl + '/api/Support/AddTicket', this.ticketData)
    .subscribe((_response) => {
      this.loaderCreate = false;
      this.getAllTickets();
      this.toastr.success(label.ticketCreated, '', {
        timeOut: environment.toasterTimeOut
      });
      this.showModal = false;
      this.files = [];
      this.fileList = [];
      this.fileTypeError = false;
      this.errorSameFile = '';
      this.validText.title = false;
      this.validText.description = false;
      this.validText.priority = false;
    },
    // istanbul ignore next
    (error) => {
      this.loaderCreate =  false;
      if(error.status !== 400){
        this.toastr.error(label.createTicketErr, '', {
          timeOut: environment.toasterTimeOut
        });
      }
    });
   
     
  }
  /**
   * To close Addticket modal dialog
   */
  closeaddModal(){
    this.showModal = false;
    this.files = [];
    this.fileTypeError = false;
    this.errorSameFile = '';
    this.validText.title = false;
    this.validText.description = false;
    this.validText.priority = false;
  }
  /**
   *  confirmation for deleting ticket modal dailog
   */
  delete(id: number) {
    this.deletePopup = true;
    this.ticketId = id;
  }
  /**
   * to delete ticket 
   */
  saveData() {
    this.deletePopup = false;
    this.loading = true;
    this.baseService.DELETE(environment.serverUrl + `/api/Support/DeleteTicket/${this.ticketId}`).subscribe((response) => {
      if (response === 'Ticket deleted successfully.') {
        this.getAllTickets();
        this.toastr.success(response, '', {
          timeOut: environment.toasterTimeOut
        });
      } else {
    // istanbul ignore next
        this.loading = false;
        this.toastr.error(response, '', {
          timeOut: environment.toasterTimeOut
        });
      }
    }, 
    // istanbul ignore next
    error => {
      this.toastr.error(error.error.text, '', {
        timeOut: environment.toasterTimeOut
      });
      this.loading = false;
    });
  }
  /**
   * to close delete ticket modal dailog on click of no
   */
  revertChanges(){
    this.deletePopup = false;
  }
  /**
   * to view ticket Deatials
   */
  viewTicket(rowdata){
    this.expandIssue = true;
    this.issueStatus = rowdata.status;
    this.ticketId = rowdata.ticketId;
    this.issueId = rowdata.ticketId;
    this.issueTitle = rowdata.title;
    this.issueDesc = rowdata.description;
    this.issuePriority = rowdata.priorityName;
    this.createdBy=  rowdata.createdBy;
    this.createdEmail = rowdata.email;
    this.createdDate = rowdata.createdDate;
    document.body.className = "no-overflow";
    this.getAllAttachmets(rowdata.ticketId);
    this.getAllComments(rowdata.ticketId);
  }

    /*
    * Function to handle file input using drag and drop or file input
    * (event) - list of files
  */
 uploadFile(event) {
   if(event.length + this.files.length > 5 || this.files.length >= 5){
    this.fileTypeError = true;
    this.errorSameFile = label.maxFileErr;
   }else {
     this.validateFiles(event);
   }
}

    /*
    * Function to handle file input using drag and drop or file input
    * (event) - list of files
  */
  validateFiles(event) {
    this.fileTypeError = false;
    this.errorSameFile = ``;
    for (let index = 0; index < event.length; index++) {
    if(event[index].type === 'image/jpeg' || event[index].type ==='image/png' || event[index].type ==='image/jpg'){
      const fileSizeCheck = this.checkFileSize(event[index].size);
      if (fileSizeCheck) {
        this.fileTypeError = true;
        this.errorSameFile = `Large file selected. ${event[index].name} is more than 10MB`;
      }
      else {
        this.fileCheck(event[index]);
      }
    }else {
      this.fileTypeError = true;
      this.errorSameFile = label.wrongFileTypeErr;
    }
    }
  }

 /*
    * Function to check file size
    *
  */
 checkFileSize(_size) {
  const sizeComp = 900;
  const mbValue = 1024;
  const hundredVal = 100;
  const tenVal = 10;
  const fSExt = ['Bytes', 'KB', 'MB', 'GB'];
  let i = 0;
  while (_size > sizeComp) {
    _size /= mbValue;
    i++;
  };
  const sizeExt = fSExt[i];
  const sizeVal = (Math.round(_size * hundredVal) / hundredVal);
  if ((sizeExt === 'MB' && sizeVal >= tenVal) || (sizeExt === 'GB')) {
    return true;
  } else {
    return false;
  }
}

/*
    * Function to handle file input using drag and drop or file input
    * (fileName) - file details
  */
 fileCheck(filedet) {
  const element = filedet;
  this.files.push(element.name);
  this.fileList.push(element);
 }

 /*
    * Function to remove attached file
  */
 deleteAttachment(index) {
  this.fileTypeError = false;
  this.errorSameFile = ``;
  this.files.splice(index, 1);
  this.fileList.splice(index, 1);
 }
 /**
   * confirmatioN modal dailog for resolve ticket
   */
 resolveTicket(){
   this.confirmResolve = true;
 }
 /**
   * closing confirmatio modal dailog for resolveticket
   */
 cancelResolve(){
  this.confirmResolve = false;
 }
 /**
   * to save resolution details
   */
 saveResolution(){
  this.confirmResolve = false;
  this.loaderFullPage = true;
  const request = {
    ticketId: this.ticketId,
    comment: this.resolution
   }
   this.baseService.POST(environment.serverUrl + '/api/Support/AddComment', request)
  .subscribe((_response) => {
    this.loaderFullPage = false;
    this.toastr.success(label.resolutionSuccess, '', {
      timeOut: environment.toasterTimeOut
    });
    this.getAllComments(this.ticketId);
    this.resolution = '';
    this.issueStatus = 'Closed';
    this.validText.resolutionText = false;
  },
  // istanbul ignore next
  (_error) => {
    this.loaderFullPage = false;
    this.toastr.error(label.errResolve, '', {
      timeOut: environment.toasterTimeOut
    });
  })
 }
 /**
   * to save reopened  comment details
   */
 saveReOpenCmt(){
   this.confirmReOpen= false;
  this.loaderFullPage = true;
  const request = {
    ticketId: this.ticketId,
    comment: this.reOpenComment
   }
   this.baseService.POST(environment.serverUrl + '/api/Support/ReOpenTicket', request)
  .subscribe((_response) => {
    this.loaderFullPage = false;
    this.validText.reOpenText = false;
    this.toastr.success(label.reOpenSuccess, '', {
      timeOut: environment.toasterTimeOut
    });
    this.getAllComments(this.ticketId);
    this.reOpenComment = '';
    this.issueStatus = 'Active';
  },
  // istanbul ignore next
  (_error) => {
    this.loaderFullPage = false;
    this.toastr.error(label.errReOpen, '', {
      timeOut: environment.toasterTimeOut
    });
  })
 }
 /**
   * for Download attachments from ticket details page
   */
 downloadFile(file){
   this.loaderFullPage = true;
   this.baseService.DOWNLOADGet(environment.serverUrl + `/api/Support/DownloadAttachment/${file.key}/${file.value}`).subscribe((data) => {
    const blob = new Blob([data]);
    saveAs(blob, file.value);
    this.loaderFullPage = false;
  },
  // istanbul ignore next
  _error => {
    this.loaderFullPage = false;
    this.toastr.error(label.errDownload, '', {
      timeOut: environment.toasterTimeOut
    });
  })
 }
/**
   * for closing full screen modal dailog
   */
 closeFullPage() {
  this.expandIssue = false;
  this.validText.reOpenText = false;
  this.validText.resolutionText = false;
  this.reOpenComment = '';
  this.resolution= '';
  document.body.className = "";
  this.getAllTickets();
 }
 /**
   *  export all tickets for admin and user roles to excel
   */
 exportTickets(){
  this.loading = true;
  let requrl;
  if(this.isAdmin === 'true'){
    requrl = '/api/Support/ExportTicketListByAppId';
  }else{
     requrl = '/api/Support/ExportTicketListByEmail';
  }
  this.baseService.DOWNLOADGet(environment.serverUrl + requrl).subscribe((data) => {
    const blob = new Blob([data]);
    saveAs(blob, 'Tickets_List.xlsx');
    this.loading = false;
  },
  // istanbul ignore next 
  (_error) => {
    this.loaderFullPage = false;
    this.toastr.error(label.errDownloadTicket, '', {
      timeOut: environment.toasterTimeOut
    });
  });
 }
 /**
   * Assigning ticket to selected admin
   */
 userSelected(row, user){
  this.loading= true;
   this.ticketId =row.ticketId; 
  this.baseService.PATCH(environment.serverUrl + `/api/Support/AssignTicket/${this.ticketId}/${user}`, '')
  .subscribe((_data) => {
    this.loading= false;
    this.getAllTickets();
    this.toastr.success(label.assignmentSuccess, '', {
      timeOut: environment.toasterTimeOut
    });
  },
  // istanbul ignore next 
  (_error) => {
      this.toastr.error(label.errAssign, '', {
      timeOut: environment.toasterTimeOut
    });
  })
 }
/**
   * Validating input filed with space check
   */
 validateText(event, checkFor) {
   if (event.target.value.replace(/\s/g, '').length) {
     if (checkFor === 'resolution') {
       this.validText.resolutionText = true;
     } else if (checkFor === 'reopen') {
       this.validText.reOpenText = true;
     } else if (checkFor === 'title') {
       this.validText.title = true;
     } else if (checkFor === 'description') {
       this.validText.description = true;
     } else {
        // For SonarQube Fix
     }
   }else{
    if (checkFor === 'resolution') {
      this.validText.resolutionText = false;
    } else if (checkFor === 'reopen') {
      this.validText.reOpenText = false;
    } else if (checkFor === 'title') {
      this.validText.title = false;
    } else if (checkFor === 'description') {
      this.validText.description = false;
    } else {
       // For SonarQube Fix
    }
   }
  
}

onPriorityTicketChange(priority) {
  this.priority = priority;
  if(priority === "1" || priority === "2" || priority === "3"){
    this.validText.priority = true;
  } else {
    this.validText.priority = false;
  }
}
}
